import React, { Component } from 'react';
import axios from "axios";
import AnalyticsRow from './analytics-row';

export default class Analytics extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
	      	categories: [],
			date: [],
			reports: [],
			reportsByCat: [],
			countlist: 0,
			countFBList: 0,
			updatedData: false
	    }
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { categories, date, reportsByCat, hasReportDataCategories } = nextProps;
		
		this.setState({
	        categories,
	        date,
	        reportsByCat
	      });
				
		if (categories && hasReportDataCategories 
			&& hasReportDataCategories[hasReportDataCategories.length - 1] 
			&& categories[categories.length - 1].value === hasReportDataCategories[hasReportDataCategories.length - 1].value && !this.state.updatedData
		) {
			this.setState({updatedData: true});
			this.props.revalidateStaleCategories();
		}
	}

	handleUpdatedDataAnalyticsRow = (data) => {
		if (this.props.showSnackBar) {
			const cate = this.props.categories.find(c => c.value === data.value);
			this.props.showSnackBar({ mess: `Thống kê mục ${cate.label} vừa mới cập nhật!`, type: "success" });
		}
	}
	
	render() {
		const { categories, date, reports, reportsByCat } = this.state;
		// console.log(reportsByCat.length);
		if(reportsByCat.length == 0){
			return (
        		<div className="spinner-border" role="status">
				  <span className="sr-only">Loading...</span>
				</div>
        	);
		}
		else{
			return (
		    	<div className="table-responsive">

	                <table className="m-0 table table-striped table-valign-middle">
	                  <thead>
	                    <tr>
	                      <th className="w--10">Chuyên mục</th>
	                      <th className="w--8">Bài</th>
	                      <th className="w--8 hide-column">KPI</th>
	                      <th className="w--8">View</th>
	                      <th className="w--8 hide-column">% KPI</th>
	                      <th className="w--8">View Google</th>
	                      <th className="w--8">% Google</th>
	                      <th className="w--8">View FB</th>
	                      <th className="w--8">% FB</th>
	                    </tr>
	                  </thead>
	                  <tbody>
	                    {reportsByCat && reportsByCat.map((data,idx) => (
	                    	data.value != "" ?
	                    		<AnalyticsRow
									key={`analytics-${idx}`}
									data={data}
									categories={categories}
									handleUpdatedData={this.handleUpdatedDataAnalyticsRow}
								/>
							: null
						))}
						{reportsByCat && reportsByCat.map((data,idx) => (
	                    	data.value == "" ?
	                    		<AnalyticsRow
									key={`analytics-${idx}`}
									data={data}
									categories={categories}
									handleUpdatedData={this.handleUpdatedDataAnalyticsRow}
								/>
							: null
						))}
	                  </tbody>

	                </table>
	            </div>
		    );
		}
	    
	}

}